function CocurricularPage(){
    document.title = 'Co-Curricular'
    return(
        <h1>
            CocurricularPage
        </h1>
    )
}

export default CocurricularPage;